import { mergeTheme } from '@gilbarbara/components';

export const theme = mergeTheme({
  colors: {
    primary: '#000',
  },
});

export const easing = 'cubic-bezier(0.35, 0.01, 0.77, 0.34);';
